import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-row">
        <div>© 2026 JM Consulting. Identity, access, and cybersecurity consulting for modern enterprises.</div>
        <div>
          <a href="https://github.com/athempeed" target="_blank" rel="noopener noreferrer">
            maintain by: athempeed
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
